import React,{useState} from "react";
import { Routes, Route, Navigate } from 'react-router-dom';

export default function AboutUs(){
    return(
        <Navigate to="/" />
    )
}